import React from 'react';

function WinPopup({ winningAmount, t, currencySymbolOrCode }) {
  return (
    <div className='popup-info'>
      <div className='popup-header'>
        <div className='header-line-left' />
        <p className='popup-header-name'>{t('YOU_WIN')}</p>
        <div className='header-line-right' />
      </div>
      <div className='popup-header-amount'>
        {winningAmount}
        {currencySymbolOrCode}
      </div>
    </div>
  );
}

export default WinPopup;
